import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';

class Breadcrumb extends Component {
	render() {
		const {
			currentPage
		  } = this.props;
		return (
			<React.Fragment>
				{isMobile ?
					<div className="u__truncate">
						<div className="body__p-left--xsmall body__p-top--small">
							<a className="u__default-link" href="/account/view/menu">Back to My Account</a>
						</div>
						<span  style={{fontSize: '2.5rem'}} className="page-header body__p-left--xsmall body__m-top--small">{currentPage}</span>
					</div>
					:
					<div id="breadcrumb" className="breadcrumb">
						<ul id="header-crumb" className="breadcrumb__header">
							<li className="breadcrumb__item"><a className="breadcrumb__link" href="http://www.homedepot.com">
								Home
							</a></li>
							<li className="breadcrumb__item"><a className="breadcrumb__link" href="/account/view/profile">My Account</a>
							</li>
							<li className="breadcrumb__item">{currentPage}
							</li>
						</ul>
						<p className="u__xlarge u--paddingBottom page-header">{currentPage}</p>
					</div>
				}
			</React.Fragment>
		);
	}
}

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/Components/Breadcrumb/Breadcrumb.js